import {paymentTypeOptions} from "../../_common/constants/options";

export const getPaymentTypeName = (paymentType) => {
  const paymentTypeOption = paymentTypeOptions
    .filter(item => item.value === paymentType)
    .filter(Boolean);
  return paymentTypeOption.length > 0 ? paymentTypeOption[0].label : '';
};